
export const Routes = {
    // pages
    Presentation: { path: "/presentation" },
    DashboardOverview: { path: "/" },
    Transactions: { path: "/transactions" },
    Settings: { path: "/settings" },
    Upgrade: { path: "/upgrade" },
    BootstrapTables: { path: "/tables/bootstrap-tables" },
    Billing: { path: "/examples/billing" },
    Invoice: { path: "/examples/invoice" },
    Signin: { path: "/examples/sign-in" },
    Signup: { path: "/examples/sign-up" },
    ForgotPassword: { path: "/examples/forgot-password" },
    ResetPassword: { path: "/examples/reset-password" },
    Lock: { path: "/examples/lock" },
    NotFound: { path: "/examples/404" },
    ServerError: { path: "/examples/500" },

    // accounts
    AccountsList: { path: "/accounts/list" },
    AccountsAdd: { path: "/accounts/add" },
    AccountsEdit: { path: "/accounts/edit/:id" },
    VoiceVideoRecordings: { path: "/accounts/recordings/:userId" },
    LikeList: { path: "/accounts/like-list" },
    CityClusters: { path: "/accounts/city-clusters" },

    // messages
    AdminMessages: { path: "/messages/admin" },
    BulkMessageSend: { path: "/messages/bulk-send" },
    QuickUnreplied: { path: "/messages/quick-unreplied" },
    UnrepliedMessages: { path: "/messages/unreplied" },
    AllMessages: { path: "/messages/all" },
    FavoriteMessages: { path: "/messages/favorites" },
    MessageReply: { path: "/messages/reply/:roomId" },
    QuickMessagesManage: { path: "/messages/quick-messages" },

    // auto message
    AutoMsgSettings: { path: "/auto-msg/settings" },
    AutoMsgPool: { path: "/auto-msg/pool" },
    MessageTemplates: { path: "/auto-msg/templates" },
    AutoMsgCampaigns: { path: "/auto-msg/campaigns" },

    BulkCallMenu: { path: "/auto-call/menu" },

    // posts
    PostsList: { path: "/posts/list" },
    CommentsList: { path: "/posts/comments" },

    // payments
    CreditPackagePayments: { path: "/payments/credit-packages" },
    VipPackagePayments: { path: "/payments/vip-packages" },
    BillingErrors: { path: "/payments/billing-errors" },

    // packages
    CreditPackages: { path: "/packages/credit" },
    CreditPackagesList: { path: "/packages/credit/list" },
    CreditPackagesAdd: { path: "/packages/credit/add" },
    CreditPackagesEdit: { path: "/packages/credit/edit/:id" },
    VipPackages: { path: "/packages/vip" },
    VipStatistics: { path: "/packages/vip-statistics" },
    VipPackagesList: { path: "/packages/vip/list" },
    VipPackagesAdd: { path: "/packages/vip/add" },
    VipPackagesEdit: { path: "/packages/vip/edit/:id" },

    // members
    MembersList: { path: "/members/list" },
    MembersAdd: { path: "/members/add" },
    MembersEdit: { path: "/members/edit/:id" },



    // stories
    StoriesList: { path: "/stories/list" },
    StoriesAdd: { path: "/stories/add" },

    // reels
    ReelsList: { path: "/reels/list" },
    ReelsAdd: { path: "/reels/add" },



    // notifications
    Notifications: { path: "/notifications" },
    PhotoNotification: { path: "/notifications/photo" },

    // evaluations
    Evaluations: { path: "/evaluations" },

    // settings
    AppSettings: { path: "/settings/app" },
    AiTraining: { path: "/ai/training" },

    // archive
    Archive: { path: "/archive" },

    // contact requests
    ContactRequests: { path: "/contact-requests" },

    // docs
    DocsOverview: { path: "/documentation/overview" },
    DocsDownload: { path: "/documentation/download" },
    DocsQuickStart: { path: "/documentation/quick-start" },
    DocsLicense: { path: "/documentation/license" },
    DocsFolderStructure: { path: "/documentation/folder-structure" },
    DocsBuild: { path: "/documentation/build-tools" },
    DocsChangelog: { path: "/documentation/changelog" },

    // components
    Accordions: { path: "/components/accordions" },
    Alerts: { path: "/components/alerts" },
    Badges: { path: "/components/badges" },
    Widgets: { path: "/widgets" },
    Breadcrumbs: { path: "/components/breadcrumbs" },
    Buttons: { path: "/components/buttons" },
    Forms: { path: "/components/forms" },
    Modals: { path: "/components/modals" },
    Navs: { path: "/components/navs" },
    Navbars: { path: "/components/navbars" },
    Pagination: { path: "/components/pagination" },
    Popovers: { path: "/components/popovers" },
    Progress: { path: "/components/progress" },
    Tables: { path: "/components/tables" },
    Tabs: { path: "/components/tabs" },
    Tooltips: { path: "/components/tooltips" },
    Toasts: { path: "/components/toasts" },
    WidgetsComponent: { path: "/components/widgets" }
};